var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 267,
    viewBox: "0 0 371 337",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2328 193.151V337H356.332V193.151H370.568V138.139H0V193.151H14.2328Z",
    fill: "#60D8F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M370.568 189.858H0V193.154H370.568V189.858Z",
    fill: "#019CC8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.506 228.105C245.506 221.261 240.118 215.712 233.473 215.712H137.092C130.447 215.712 125.061 221.261 125.059 228.105V235.066C125.061 241.909 130.447 247.457 137.092 247.457H233.473C240.118 247.457 245.506 241.909 245.506 235.066V228.105Z",
    fill: "#1A202C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M362.08 0H30.151V65.3291H362.08V0Z",
    fill: "#E2E8F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M339.189 65.3137H20.9143V136.373H339.189V65.3137Z",
    fill: "#E2E8F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.188 65.3287L20.9143 79.8771V65.3287H339.188Z",
    fill: "#A0AEC0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.093 128.051L292.984 164.71L158.544 129.701L333.093 128.051Z",
    fill: "#E2E8F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustBox);
export default __webpack_public_path__ + "static/media/illust-box.98d15cd3e12d199afe1db88406526a56.svg";
export { ForwardRef as ReactComponent };